<template>
  <div>
    <PageHeader
      has-return
      :page="pageInfo"
      :actions="pageActions"
      left-side-class="col-12 col-lg-8"
      right-side-class="col-12 col-lg-4 d-flex align-items-center justify-content-end"
      @onReturn="() => $router.go(-1)"
    />
    <div
      v-if="isOpenCreateFollowUp"
      class="bg-secondary-28 border-color--gray-5 rounded p-4"
    >
      <follow-up
        :initial-data="followup"
        :is-from-previous="isFromPrevious"
        :academic-year-id="academicYearId"
        @save="handleSaveFollowUp"
        @cancel="handleCancelFollowUp"
      />
    </div>
    <custom-separator class="my-4" text="Historial de Seguimiento de Plan" />
    <div v-if="results.length > 0">
      <div v-for="item in results" :key="item.followUpId" class="mb-3">
        <follow-up-history-result :item="item" />
      </div>
      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="handlePageChange"
      />
    </div>
    <div v-else>
      <custom-result-not-found />
    </div>
  </div>
</template>

<script>
// libs
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import CustomSeparator from 'custom-separator';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';

// services
import {
  getFollowUps as _getFollowUps,
  saveFollowUp as _saveFollowUp,
  canFollowUpInHistory as _canFollowUpInHistory,
  getLatestFollowup as _getLatestFollowup,
} from '@/services/operations/action-plan.js';

// child components
import { FollowUpHistoryResult } from './components';
import { FollowUp } from '@/views/pei/location-alternatives/search/actionPlan/components';

//mixins
import mixAlert from '@/mixin/alert.mixin';

export default {
  name: 'FollowUpHistory',
  mixins: [mixAlert],
  components: {
    PageHeader,
    ActionButton,
    CustomSeparator,
    Pagination,
    CustomResultNotFound,
    FollowUpHistoryResult,
    FollowUp,
  },
  data: () => ({
    followup: {},
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: 5,
    },
    results: [],
    isOpenCreateFollowUp: false,
    canFollowUp: false,
  }),
  computed: {
    isFromPrevious() {
      return Boolean(this.$route.params.isFromPrevious);
    },
    actionPlanId() {
      return this.$route.params.actionPlanId;
    },
    academicYearId() {
      return this.$route.params.academicYearId;
    },
    pageInfo() {
      return {
        icon: 'fas fa-history',
        title: 'Histórico de Seguimiento de Plan',
        routes: [
          'Inicio',
          'PEI',
          'Catálogo de Alternativa de Ubicación',
          'Histórico de Seguimiento de Plan',
        ],
      };
    },
    pageActions() {
      return [
        {
          name: 'Dar Seguimiento de Plan',
          icon: 'fa fa-file-alt',
          variant: 'success',
          text: 'Dar Seguimiento de Plan',
          visible: !this.isOpenCreateFollowUp && this.canFollowUp,
          click: () => {
            this.isOpenCreateFollowUp = true;
          },
        },
      ];
    },
  },
  mounted() {
    Promise.all([
      this.fetchFollowUps(),
      this.fetchCanFollowUpInHistory(),
      this.getLast(),
    ]).catch((err) => {
      this.ShowToast('Error', err.response.data.message, 'error');
    });
  },
  methods: {
    async fetchFollowUps(page = 1) {
      const response = await _getFollowUps(
        this.actionPlanId,
        page,
        this.pagination.pageSize
      ).catch((err) => {
        this.ShowToast('Error', err.response.data.message, 'error');
      });
      if (response?.data) {
        const data = response.data;
        this.results = data.data;
        this.pagination = {
          ...this.pagination,
          count: data.count,
          currentPage: data.currentPage,
          pageCount: data.pageCount,
          totalItemCount: data.totalItemCount,
        }
      }
    },
    async fetchCanFollowUpInHistory() {
      const response = await _canFollowUpInHistory(
        this.actionPlanId,
        this.academicYearId
      ).catch((err) => {
        this.ShowToast('Error', err.response.data.message, 'error');
      });
      if (response?.data) {
        this.canFollowUp = response.data;
      }
    },
    async getLast() {
      if (!this.isFromPrevious) {
        return;
      }

      const followupData =
        (await _getLatestFollowup(this.actionPlanId, this.academicYearId))
          ?.data || {};
      this.followup = followupData;
    },
    handlePageChange(page) {
      this.fetchFollowUps(page);
    },
    async handleSaveFollowUp({ questions, staffName, staffPositionNumber, comment }) {
      const questionMap = Object.fromEntries(
        questions.map((question) => [question.name, question.value])
      );

      const payload = {
        ...questionMap,
        staffName,
        staffPositionNumber,
        actionPlanId: +this.actionPlanId,
        academicYearId: +this.academicYearId,
        comment: comment,
      };
      const response = await _saveFollowUp(payload).catch((err) => {
        this.ShowToast('Error', err.response.data.message, 'error');
      });
      if (response?.data) {
        this.ShowToast(
          'Éxito',
          'El seguimiento fue guardado correctamente.',
          'success'
        );
        this.handleCancelFollowUp();
        await this.fetchFollowUps();
        await this.getLast();
      }
    },
    handleCancelFollowUp() {
      this.isOpenCreateFollowUp = false;
    },
  },
};
</script>
